export interface BuildImageAltTextInput {
  title: string;
  colorName?: string;
  cmsAltText?: string | null;
  viewLabel: string;
}

/**
 * Builds the "<title> - <color> - <view>" alt text required for every gallery
 * image. The CMS alt text wins over the generated view label, and missing parts
 * collapse instead of leaving empty separators behind.
 */
export function buildImageAltText({
  title,
  colorName,
  cmsAltText,
  viewLabel,
}: BuildImageAltTextInput): string {
  const view = cmsAltText?.trim() || viewLabel;

  return [title.trim(), colorName?.trim(), view.trim()].filter(Boolean).join(' - ');
}
